import { ConsentValidator } from '@atlassian/community-library';
import { FunctionComponent, useMemo } from 'react';
import { useRouterActions } from 'react-resource-router';
import { getAuthUrl } from 'utils';
import useLoggedInUser from 'utils/useLoggedInUser';
import WelcomeIllustrations from '../../assets/images/welcome-illustration.png';

export type ConsentWrapperProps = {
  profileHasConsented: boolean;
  children: React.ReactNode;
};

export const ConsentWrapper: FunctionComponent<ConsentWrapperProps> = ({
  profileHasConsented,
  children,
}: ConsentWrapperProps) => {
  const { push } = useRouterActions();
  const currentPage = encodeURIComponent(globalThis.location.href);
  const user = useLoggedInUser() || {};

  const logoutHref = useMemo(() => {
    return getAuthUrl('logout', {
      prompt: 'none',
      experience: 'entry-auth',
      redirectUrl: currentPage,
    });
  }, [currentPage]);

  const onConsentError = () => {
    push('/user/error/consent_failed');
  };

  return (
    <ConsentValidator
      onLogout={() => push(logoutHref)}
      aaid={user.accountId}
      coverImageSrc={WelcomeIllustrations}
      isUserConsented={profileHasConsented}
      onConsentError={onConsentError}
    >
      {children}
    </ConsentValidator>
  );
};
